module.exports = "<input type=\"text\" class=\"form-control\" [formControl]=\"primaryEmail\" rows=\"1\" (keypress)=\"onKeyPressHandler($event)\"\n          [placeholder]=\"'Add a valid email id'\"/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/output/mail/mail-address/mail-address.component.html
// module id = 1441
// module chunks = 1